/* eslint-disable react/jsx-indent-props */
import React, { useEffect, useRef, useState } from "react";
import Layout from "../components/layout";
import { observer } from "mobx-react-lite";
import { useStores } from "../use.store";
import ACA from "@adactive/adsum-utils/services/ClientAPI";
import {
  AdsumLoader,
  AdsumWebMap,
  ArrowPathPatternOptions,
  DotPathBuilder,
  DotPathBuilderOptions,
  DotPathSectionDrawer,
  DotPathSectionDrawerOptions,
  PinUserObject,
  SingleFloorAnimation,
} from "@adactive/adsum-web-map";
import { MainActions, Map, SelectionActions } from "@adactive/arc-map";
import PlacesController from "@adactive/arc-map/src/controllers/PlacesController";
import store from "../store/index";
import {
  getDrawPathSectionOptions,
  labelStyle,
  s3Url,
} from "../utils/constants";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import WayFindingControls, {
  WayFindingControlsActions,
} from "@adactiveasia/adasia-wayfindingcontrols";
import { render } from "react-dom";
import {
  checkComputedPath,
  getPathNameParams,
  getPlace,
  getPoi,
} from "../utils/functions";
import _, { first } from "lodash";
import SearchView from "../components/SearchView";
import Tour from "reactour";
import { BottomSheet } from "react-spring-bottom-sheet";
import selectionController from "@adactive/arc-map/src/controllers/SelectionController";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import Lottie from "react-lottie";
import * as animationData from "../assets/lottie/Animation - Loading.json";
import { setAwm, SetSelectedPoi, SetWillTMTT } from "../store/app/appActions";
import { setIsActionEnabled } from "../store/app/appActions";
import CustomLabelComponent from "../components/CustomLabelComponent";
import MarqueeComponent from "../components/MarqueeComponent";
import "./Home.css";
import switchImage from "../assets/images/switch.svg";
import repeat from "../assets/images/repeat.png";
import defaultImage from "../assets/images/default.png";
import closeIcon from "../assets/images/close.svg";
import locationIcon from "../assets/images/location.svg";
import stairIcon from "../assets/images/stair.svg";
import liftIcon from "../assets/images/lift.svg";
import closeIcon2 from "../assets/images/close2.svg";
import { logAnalyticsEvent } from "../services/firebaseAnalytics";

const Home = observer(() => {
  const { generalStore } = useStores();
  const mapState = useSelector((state) => state.map.state);
  const [awmContainerRef] = useState(React.createRef());
  // const [awm, setAWMAP] = useState(null);
  const { wayfindingState, wayFindingControlsState, awm, isActionEnabled } =
    useSelector(
      (state) => ({
        wayfindingState: state.map.wayfindingState,
        wayFindingControlsState: state.wayFindingControls,
        awm: state.app.awm,
        isActionEnabled: state.app.isActionEnabled,
      }),
      shallowEqual
    );
  const [allFloors, setAllFloors] = useState([]);
  const [defaultFloor, setDefaultFloor] = useState({});
  const [searchView, setShowSearchView] = useState(false);
  const [showDetailDestination, setShowDetailDestination] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useHistory();
  const [loadingPath, setLoadingPath] = useState(false);
  const [loadingMap, setLoadingMap] = useState(false);
  const [firstInit, setFirstInit] = useState(true);
  const [destinationObject, setDestinationObject] = useState(null);
  const queryParameters = new URLSearchParams(window.location.search);
  const start = queryParameters.get("start");
  const end = queryParameters.get("end");
  const pattern = /^([A-Za-z "/]{4,})$/;
  const [showCustomLabel, setShowCustomLabel] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  const [pathExist, setPathExist] = useState(false);
  const [stairAccessible, setStairAccessible] = useState(false);
  const [liftAccessible, setLiftAccessible] = useState(false);
  const [showSwitch, setShowSwitch] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [pathParams, setPathParams] = useState(null);
  const headerRef = useRef(null);
  const sheetRef = useRef();

  var allowLoopIndex = 0;

  useEffect(() => {
    setHeaderHeight(headerRef.current.clientHeight);
  });

  useEffect(() => {
    generalStore.activePage = "wayfinder";
    initDevice();
    setIsActionEnabled(true);
    // Reset wayfinding status to ensure map work properly when from and destination location already filled
    setTimeout(
      () => {
        generalStore.isWayfindingRunning = false;
        resetAll();
      },
      firstInit ? 2000 : 0
    );
  }, []);

  const setPredefinedLocation = () => {
    const getPathParams = getPathNameParams();
    setPathParams(getPathParams);
    setTimeout(() => {
      try {
        if (awm && pathParams) {
          if (pathParams !== "/") {
            setUserPositionFromParam(pathParams);
          }
        }
      } catch (e) {
        console.log("Error when loadMap", e);
      }
    }, 2000);
  };

  useEffect(() => {
    loadMap();
    if (firstInit) setPredefinedLocation();
  }, [mapState, awm]);

  useEffect(() => {
    if (generalStore.searchAction == "") {
      setShowSearchView(false);
    }
  }, [generalStore.searchAction]);

  useEffect(() => {
    setLoadingMap(firstInit);
  }, [firstInit]);

  // check path availability and stair & lift accessibility
  useEffect(() => {
    if (showDetailDestination) {
      setLoadingMap(true);
      checkComputedPath(destinationObject, true).then((pathViaLift) => {
        checkComputedPath(destinationObject, false).then((pathNonLift) => {
          setStairAccessible(pathNonLift);
          setLiftAccessible(pathViaLift);
          setPathExist(pathViaLift || pathNonLift);
          setLoadingMap(false);
        });
      });
    }
  }, [showDetailDestination]);

  useEffect(() => {
    if (generalStore.isWayfindingRunning) {
      setShowDetailDestination(false);
    }
  }, [generalStore.isWayfindingRunning]);

  useEffect(() => {
    setTimeout(
      () => {
        setFirstInit(false);
        if (generalStore.from != null && awm) {
          handleUpdateUserPosition(
            generalStore.from.floor_id,
            generalStore.from.shape_id,
            generalStore.from.place_id
          );

          if (generalStore.to == null) {
            setstartIndex(1);
            setisTourOpen(true);
          } else {
            setisTourOpen(false);
            setTimeout(() => {
              setShowDetailDestination(true);
            }, 500);
          }
          setShowDetailDestination(false);
        } else {
          resetAll();
        }
      },
      firstInit ? 2000 : 0
    );
  }, [generalStore.from, awm]);

  useEffect(() => {
    setTimeout(
      () => {
        setFirstInit(false);
        if (generalStore.to != null && awm) {
          handleUpdatePoiPosition(
            generalStore.to.floor_id,
            generalStore.to.shape_id,
            generalStore.to.place_id
          );

          if (generalStore.from == null) {
            setstartIndex(0);
            setisTourOpen(true);
            if (pathParams !== null && pathParams !== "/") {
              setisTourOpen(false);
            }
          } else {
            setisTourOpen(false);
            setTimeout(() => {
              setShowDetailDestination(true);
            }, 500);
          }
          if (pathParams !== null && pathParams !== "/") {
            setShowDetailDestination(true);
          }
        } else {
          resetAll();
        }
      },
      firstInit ? 2000 : 0
    );
  }, [generalStore.to, awm]);

  useEffect(() => {
    setTimeout(
      () => {
        setFirstInit(false);
        if (awm) {
          // show switch when one or both place selected
          setShowSwitch(generalStore.to || generalStore.from);

          // for highlighting place
          if (generalStore.to) {
            highlightPlace(generalStore.to, "#17274F", true);
          } else {
            unhighlightPlacesExcept(generalStore.from);
          }
          if (generalStore.from) {
            highlightPlace(generalStore.from, "#C6B193");
          } else {
            unhighlightPlacesExcept(generalStore.to);
          }
        }
      },
      firstInit ? 2000 : 0
    );
  }, [generalStore.to, generalStore.from, awm]);

  useEffect(() => {
    if (awm && wayfindingState.drawing && wayFindingControlsState.destination) {
      generalStore.activeFloor = awm.sceneManager.currentGround;
    }
    if (
      wayFindingControlsState.takeMeThere &&
      wayFindingControlsState.takeMeThere[0]
    ) {
      const object = awm.objectManager.getSpace(
        wayFindingControlsState.takeMeThere[0].shape_id
      );
      if (generalStore.fromSearchAction) {
        wayFindingControlsState.takeMeThere[0].poiName = generalStore.to.name;
      } else {
        object.labels.forEach((label) => {
          wayFindingControlsState.takeMeThere[0].poiName = label.text;
          return;
        });
      }
    }
  }, [wayfindingState.drawing, wayFindingControlsState.destination]);

  useEffect(() => {
    if (
      (wayFindingControlsState &&
        wayFindingControlsState.placeDestination &&
        wayFindingControlsState.placeDestination.name &&
        wayFindingControlsState.finish) ||
      !generalStore.isWayfindingRunning
    ) {
      dispatch(setIsActionEnabled(true));
    } else {
      dispatch(setIsActionEnabled(false));
    }
  }, [
    wayFindingControlsState &&
      wayFindingControlsState.placeDestination &&
      wayFindingControlsState.placeDestination.name &&
      wayFindingControlsState.finish,
    generalStore.isWayfindingRunning,
  ]);

  const [isTourOpen, setisTourOpen] = useState(false);
  const [startIndex, setstartIndex] = useState(0);
  const accentColor = "#5cb7b7";
  const tourConfig = [
    {
      selector: '[data-tut="reactour__iso"]',
      // content: `Please fill your current location to start routing maps.`,
      content: () => (
        <div className="flex flex-col gap-2 w-full">
          <div className="flex flex-row gap-2">
            <img
              src={require("../assets/images/info-circle.png")}
              className="w-4 h-4"
            />
            <span className="text-sm font-medium">Ready to find your way?</span>
          </div>
          <div className="w-full text-xs">
            Enter your current location to get directions
          </div>
        </div>
      ),
      position: "top",
    },
    {
      selector: '[data-tut="to"]',
      // content: `Please fill your current location to start routing maps.`,
      content: () => (
        <div className="flex flex-col gap-2 w-full">
          <div className="flex flex-row gap-2">
            <img
              src={require("../assets/images/info-circle.png")}
              className="w-4 h-4"
            />
            <span className="text-sm font-medium">Set Your Destination</span>
          </div>
          <div className="w-full text-xs">
            Tell us where you're going, and we'll show you the way.
          </div>
        </div>
      ),
      position: "bottom",
    },
  ];

  const initDevice = async () => {
    const getPathParams = getPathNameParams();
    try {
      const awMap = new AdsumWebMap({
        loader: new AdsumLoader({
          entityManager: generalStore.aca.entityManager, // Give it in order to be used to consume REST API
          deviceId: generalStore.deviceConfig.config.map.deviceId, // The device Id to use
          wireframeSpaces: true,
          wireframeSpacesOptions: { color: 0x5a5b5a },
        }), // The loader to use
        camera: {
          center: true,
          centerOnOptions: {
            fitRatio: 2,
            minDistance: 200,
            altitude: 45,
          },
        },
        engine: {
          container: awmContainerRef.current,
        },

        wayfinding: {
          pathBuilder: new DotPathBuilder(
            new DotPathBuilderOptions({
              patternSpace: 2, // 4,
              patternSize: 1.5, // 2
              pattern: new ArrowPathPatternOptions({
                color: "#be272f",
              }),
            }),
            new DotPathSectionDrawerOptions({
              center: true,
              centerOnOptions: {
                fitRatio: 1.2,
                minDistance: 200,
                altitude: 40,
              },
              oriented: true,
              showDelay: 500,
            })
          ),
          userObject: new PinUserObject({
            color: "#be272f",
            size: getPathParams !== null && getPathParams !== "/" ? 6 : 0,
          }),
          pathSectionDrawer: new DotPathSectionDrawer({
            center: true,
            oriented: true,
          }),
        },
        scene: {
          animation: new SingleFloorAnimation({
            keepSiteVisible: false,
            bounce: false,
            center: true,
            centerOnOptions: {
              fitRatio: 2,
              minDistance: 200,
              // altitude: 45,
            },
          }),
        },
      });
      // setAWMAP(awMap);
      dispatch(setAwm(awMap));
      generalStore.awm = awMap;
      generalStore.activeFloor = awm.defaultFloor;
      setTimeout(() => {
        if (end != null) {
          const pois = generalStore.aca.getPoisFromPlace(end);
          const poi = pois[0];
          if (poi != null) {
            const places = generalStore.aca.getPlace(end);

            const tags =
              poi.tags && poi.tags.values && poi.tags.values.length > 0
                ? generalStore.aca.getTagBy({
                    id: Array.from(poi.tags.values)[0].value,
                  })[0].name
                : null;
            const name = pattern.test(places.name) ? "" : places.name;
            // to help hide custom label
            allowLoopIndex = 0;
            generalStore.to = {
              ...poi,
              places: name,
              tags,
              floor_id: places.floor_id,
              shape_id: places.shape_id,
            };
          }
        }

        if (start != null) {
          const pois = generalStore.aca.getPoisFromPlace(start);
          const poi = pois[0];
          if (poi != null) {
            const places = generalStore.aca.getPlace(start);

            const tags =
              poi.tags && poi.tags.values && poi.tags.values.length > 0
                ? generalStore.aca.getTagBy({
                    id: Array.from(poi.tags.values)[0].value,
                  })[0].name
                : null;
            const name = pattern.test(places.name) ? "" : places.name;
            generalStore.from = {
              ...poi,
              places: name,
              tags,
              floor_id: places.floor_id,
              shape_id: places.shape_id,
            };
          }
        }
      }, 2000);
    } catch (e) {
      console.log("Error when init device", e);
    }
  };

  const loadMap = async () => {
    try {
      if (awm && mapState == "idle") {
        MainActions.zoomAction(100);
      }
    } catch (e) {
      console.log("Error when loadMap", e);
    }
  };
  const onMapClicked = (object) => {
    if (!generalStore.isWayfindingRunning) {
      if (object && object.placeId) {
        const pois = generalStore.aca.getPoisFromPlace(object.placeId);
        const tempPoi = pois[0];
        let poi;
        poi = tempPoi;

        if (object.id === 1319) {
          pois.forEach((data) => {
            if (data.id === 213220) {
              poi = data;
            }
          });
        }

        if (object.id === 1316) {
          pois.forEach((data) => {
            if (data.id === 218508) {
              poi = data;
            }
          });
        }

        if (poi) {
          logAnalyticsEvent("destination", {
            poi: `${poi.name}`,
          });
          if (generalStore.to == null) {
            generalStore.fromSearchAction = false;
            const places = generalStore.aca.getPlace(object.placeId);

            const tags =
              Array.from(poi.tags.values).length > 0
                ? generalStore.aca.getTagBy({
                    id: Array.from(poi.tags.values)[0].value,
                  })[0].name
                : null;
            const name = pattern.test(places.name) ? "" : places.name;
            setDestinationObject(object);

            // to help hide custom label
            allowLoopIndex = 0;

            generalStore.to = {
              ...poi,
              places: name,
              tags,
              floor_id: places.floor_id,
              shape_id: places.shape_id,
            };
            handleSetSelectedPoi(generalStore.to);
          } else if (generalStore.from == null) {
            const places = generalStore.aca.getPlace(object.placeId);

            const tags =
              poi.tags && poi.tags.values && poi.tags.values.length > 0
                ? generalStore.aca.getTagBy({
                    id: Array.from(poi.tags.values)[0].value,
                  })[0].name
                : null;
            const name = pattern.test(places.name) ? "" : places.name;

            generalStore.from = {
              ...poi,
              places: name,
              tags,
              floor_id: places.floor_id,
              shape_id: places.shape_id,
            };
            handleSetSelectedPoi(generalStore.from);
          }
        }
      }
    }
  };

  const renderMap = () => {
    return (
      <Map
        store={store}
        awm={awm}
        isOpen={true}
        autoSelectOnClick={false}
        className={`w-full h-full absolute z-10`}
        onClick={(object) => onMapClicked(object)}
        getDrawPathSectionOptions={getDrawPathSectionOptions}
        highlightColor="#17274F"
        zoom={{
          min: 10,
          max: 2100,
        }}
      >
        <WayFindingControls
          awm={awm}
          kioskPlace={defaultFloor}
          isArrivedLabel={false}
          destinationLabelText=""
          arrivalLabelStyle={labelStyle.arrival}
          icLabelText=" Please proceed to "
          fullCustomIcLabelText
          customResetFunction={() => {}}
        />
        <div id="adsum-web-map-container" ref={awmContainerRef} />
        {wayFindingControlsState &&
        wayFindingControlsState.placeDestination &&
        wayFindingControlsState.placeDestination.name &&
        defaultFloor !== wayFindingControlsState.placeDestination
          ? !wayFindingControlsState.finish && (
              <div className="drawing-status">
                {wayFindingControlsState.interchangeLabel &&
                wayFindingControlsState.interchangeLabel.length > 0
                  ? wayFindingControlsState.interchangeLabel[
                      wayFindingControlsState.interchangeLabel.length - 1
                    ]
                  : "Go to nearest Lift / Escalator"}
              </div>
            )
          : null}
      </Map>
    );
  };

  const changeFloor = (floor) => {
    dispatch(MainActions.changeFloorAction(floor.id));
    generalStore.activeFloor = floor;
  };

  const handleUpdateUserPosition = async (floor_id, shape_id, place_id) => {
    const object = awm.objectManager.getSpace(shape_id);

    const updateUserPosition = async () => {
      const floor = await awm.objectManager.getFloor(floor_id);
      changeFloor(floor);
      const objectPosition = object._mesh.position;

      await awm.wayfindingManager.setUserAdsumPosition(
        { ...objectPosition, z: 2 },
        floor,
        false
      );
      await awm.wayfindingManager._doAdsumUserPositionUpdate(
        { ...objectPosition, z: 2 },
        floor
      );
      await awm.objectManager.user.setDisplayMode("visible");
      await awm.sceneManager.setCurrentFloor(floor, true);
      await awm.cameraManager.centerOn(object, true, {
        zoom: true,
        maxDistance: 2100,
        minDistance: 10,
      });
    };
    updateUserPosition();
  };

  const handleUpdatePoiPosition = async (floor_id, shape_id, place_id) => {
    const object = awm.objectManager.getSpace(shape_id);
    setDestinationObject(object);
  };

  const highlightPlace = (poi, color, isPoiTo = false) => {
    if (poi && color) {
      const findObject = awm.objectManager.getSpace(poi.shape_id);

      if (!findObject) {
        return;
      }

      findObject.labels.forEach((label) => {
        label.setScale(1, 1, 1);
      });
      findObject.setColor(color);
    }
  };

  const unhighlightPlacesExcept = (poi) => {
    if (poi) {
      const findObject = awm.objectManager.getSpace(poi.shape_id);
      awm.objectManager.spaces.forEach((v) => {
        if (v !== findObject) {
          v.resetColor();
        }
      });
    } else {
      awm.objectManager.spaces.forEach((v) => {
        v.resetColor();
      });
    }
  };

  const onTakeMeThere = async (viaLift) => {
    try {
      setLoadingPath(true);
      setTimeout(() => {
        PlacesController.sortAllAdsumPlaces();
      }, 1000);

      // setIsSourceChanged(false);
      resetAll();
      generalStore.isWayfindingRunning = true;

      // resetMapAndWayFinding(false, false, false, true);
      // generalStore.isWayfindingRunning = false;
      setTimeout(async () => {
        if (generalStore.to.shape_id) {
          if (checkComputedPath(destinationObject)) {
            // highlightMultiplePlaces(generalStore.from, "#C6B193");
            dispatch(WayFindingControlsActions.finish(false));
            if (getPoi(destinationObject) && getPlace(destinationObject))
              tmtt(
                getPoi(destinationObject)[0],
                [getPlace(destinationObject)],
                viaLift
              );
          } else {
            console.log("There's no path");
            // setShowDetailDestination(false);
            // resetAll();
          }
        } else {
          resetAll();
        }
        setLoadingPath(false);
      }, 2000);
      // if (isActionEnabled) {
      //   if (!selectedFrom && !isPathParam) {
      //     setIsFormModalOpen(true);
      //   } else {

      //   }
      // }
    } catch (e) {
      console.log("Error when wayfinding", e);
    }
  };

  const tmtt = (poi, poiPlace, pmr) => {
    dispatch(WayFindingControlsActions.tmtt(poi, poiPlace, pmr));
    if (pathParams == "/" || pathParams == null) {
      handleSetWillTMTT(generalStore.from, generalStore.to);
    }
  };

  const resetMapAndWayFinding = (
    reset,
    resetMap,
    resetMapAnimatedOption,
    resetWayfinding
  ) => {
    dispatch(
      WayFindingControlsActions.resetMapAndWayFinding(
        reset,
        resetMap,
        resetMapAnimatedOption,
        resetWayfinding
      )
    );
  };

  const resetAll = () => {
    if (awm) {
      resetMapAndWayFinding(true, false, true, true);
      generalStore.isWayfindingRunning = false;
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const checkPlaceIdActive = (placeId) => {
    return (
      generalStore.to &&
      generalStore.from &&
      generalStore.to.place_id !== placeId &&
      generalStore.from.place_id !== placeId
    );
  };

  const checkFloorIdActive = (floorId) => {
    return (
      generalStore.to &&
      generalStore.from &&
      generalStore.to.floor_id !== floorId &&
      generalStore.from.floor_id !== floorId
    );
  };

  const handleSetSelectedPoi = (poi) => {
    if (isActionEnabled) {
      const object = awm.objectManager.getSpace(poi.shape_id);
      const pois = ACA.getPoisFromPlace(object.placeId);
      const place = ACA.getPlace(object.placeId);
      if (pois && pois.length > 0) {
        if (Array.from(pois[0].categories.length > 0)) {
          const categoryId = pois[0].categories[0].id;
          const checkCategory = ACA.getCategoriesBy({ id: [categoryId] });
          const isAmenities =
            !checkCategory && checkCategory[0].name === "Amenities";
          if (!isAmenities) {
            const poiPlaces = pois.map((poi) => {
              const places = Array.from(poi.places.values).map((place) =>
                ACA.getPlace(place.value)
              );
              return {
                ...poi,
                places,
                placeId: object.placeId,
                locations: [place],
              };
            });
            dispatch(SetSelectedPoi(poiPlaces[0]));
          }
        }
      }
    }
  };

  const handleSetWillTMTT = (fromPoi, toPoi) => {
    const fromObject = awm.objectManager.getSpace(fromPoi.shape_id);
    const toObject = awm.objectManager.getSpace(toPoi.shape_id);

    dispatch(SetWillTMTT(fromObject, toObject));
  };

  const handleSwitch = () => {
    setisTourOpen(false);
    const temp = generalStore.to;
    generalStore.to = generalStore.from;
    generalStore.from = temp;
  };

  const getPathNameParams = () => {
    const allUrl = window.location.href;
    const splittedPath = allUrl.split("=");
    if (splittedPath && splittedPath.length && splittedPath[1]) {
      return {
        x: parseFloat(splittedPath[1].replace("&y", ""), 10),
        y: parseFloat(splittedPath[2].replace("&z", ""), 10),
        z: parseFloat(splittedPath[3].replace("&floor", ""), 10),
        floorId: parseInt(splittedPath[4], 10),
      };
    }
    return "/";
  };
  const setUserPositionFromParam = async (object) => {
    try {
      logAnalyticsEvent("qrCode", {
        qrCode: `qrCode`,
      });
      const floor = await awm.objectManager.getFloor(object.floorId);
      changeFloor(floor);
      const objectPosition = { x: object.x, y: object.y, z: object.z };
      await awm.wayfindingManager.setUserAdsumPosition(
        objectPosition,
        floor,
        false
      );
      await awm.wayfindingManager._doAdsumUserPositionUpdate(
        objectPosition,
        floor
      );
      await PlacesController.sortAllAdsumPlaces();
      await selectionController.select(object);
      await selectionController.select({});

      await awm.cameraManager.centerOn(awm.objectManager.user, true, {
        zoom: false,
      });
      await awm.objectManager.user.setDisplayMode("visible");
    } catch (err) {
      console.log(err);
    }
  };

  const logoSupremeCourt = "logo-supreme-court";
  const logoFamilyJustice = "logo-family-justice";
  const logoStateCourt = "logo-state-court";
  return (
    <Layout>
      {searchView && <SearchView />}
      {loadingPath && (
        <div className="w-screen h-screen fixed z-[9999999] bg-[#00000066] top-0 flex flex-col items-center justify-center loading-map">
          <div className="w-[200px] h-[200px]">
            <Lottie options={defaultOptions} />
          </div>
          <span className="font-bold text-xs text-white mt-[-60px]">
            Finding your best path..
          </span>
        </div>
      )}
      {loadingMap && (
        <div className="w-screen h-screen fixed z-[9999999] bg-[#00000066] top-0 flex flex-col items-center justify-center loading-map">
          <span className="font-bold text-xs text-white mt-[-60px]">
            Loading map..
          </span>
        </div>
      )}
      {generalStore.to && showDetailDestination && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex rounded-lg justify-center items-center z-[90]">
          <div className="bg-white rounded-lg shadow-lg w-96">
            <div className="flex flex-col h-full w-full">
              <div className="h-full w-full overflow-y-scroll scrollbar-hide">
                <div className="relative">
                  <img
                    src={(() => {
                      try {
                        const description = JSON.parse(
                          generalStore.to.description
                        );
                        return description.logo
                          ? `${s3Url}/poi/${description.logo}`
                          : defaultImage;
                      } catch (error) {
                        // If JSON.parse fails (i.e. poi.description is plain string)
                        return defaultImage;
                      }
                    })()}
                    className="w-full rounded-t-lg"
                    alt="Image"
                  />

                  <div className="absolute top-0 right-0 p-2">
                    <img
                      className="h-6 w-6"
                      src={closeIcon}
                      onClick={() => {
                        setShowDetailDestination(false);
                      }}
                    />
                  </div>
                </div>
                <div className="p-4 flex flex-col gap-2">
                  <MarqueeComponent
                    content={generalStore.to.name}
                    spanClassName="text-lg font-bold"
                  />
                  <div className="flex flex-row gap-2 items-center justify-center">
                    <img
                      src={locationIcon}
                      className="object-contain w-3 h-3"
                    />
                    <div className="flex-grow">
                      <span className="text-primary font-light text-sm line-clamp-1">
                        {(() => {
                          try {
                            const description = JSON.parse(
                              generalStore.to.description
                            );

                            return description.location
                              ? description.location
                              : "";
                          } catch (error) {
                            return "";
                          }
                        })()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {pathExist && (
                <div className="px-4 pb-4">
                  <button
                    className="bg-[#E09948] w-full text-white font-bold py-3 px-4 rounded-full mt-4"
                    onClick={() => {
                      // if same to and from place share same floor, then directly tmtt
                      const isSameFloor =
                        generalStore.from &&
                        generalStore.to &&
                        generalStore.from.floor_id === generalStore.to.floor_id;
                      const isDestinationFloor =
                        pathParams &&
                        pathParams !== "/" &&
                        pathParams.floorId === generalStore.to?.floor_id;
                      if (isSameFloor || isDestinationFloor) {
                        generalStore.tmtType = "stair";
                        setOpenModal(false);
                        onTakeMeThere(false);
                      } else {
                        setOpenModal(true);
                      }
                    }}
                  >
                    Get Direction
                  </button>
                </div>
              )}
            </div>

            {openModal && (
              <div className="w-full h-screen absolute top-0 left-0 z-50 bg-[#00000066] flex flex-col items-center justify-center p-4">
                <div className="flex flex-col bg-white w-full rounded-lg p-4 gap-4">
                  <div className="flex flex-row justify-end">
                    <img
                      src={closeIcon}
                      alt=""
                      onClick={() => {
                        setOpenModal(false);
                      }}
                    />
                  </div>
                  <div className="flex flex-row justify-between gap-4">
                    {stairAccessible && (
                      <div
                        className="flex flex-col gap-2 items-center justify-center px-4 py-8 bg-[#FCF4EB] rounded-lg w-full"
                        onClick={() => {
                          generalStore.tmtType = "stair";
                          setOpenModal(false);
                          onTakeMeThere(false);
                        }}
                      >
                        <img
                          src={stairIcon}
                          className="aspect-square w-20 h-20"
                        />
                        <span className="font-bold text-sm text-gray-500">
                          Escalator Access
                        </span>
                      </div>
                    )}
                    {liftAccessible && (
                      <div
                        className="flex flex-col gap-2 items-center justify-center px-4 py-8 bg-[#FCF4EB] rounded-lg w-full"
                        onClick={() => {
                          generalStore.tmtType = "lift";
                          setOpenModal(false);
                          onTakeMeThere(true);
                        }}
                      >
                        <img
                          src={liftIcon}
                          className="aspect-square w-20 h-20"
                        />
                        <span className="font-bold text-sm text-gray-500">
                          Lift Access
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <Tour
        onRequestClose={() => {
          setisTourOpen(false);
        }}
        steps={tourConfig}
        isOpen={isTourOpen}
        maskClassName="mask"
        className="helper"
        showNavigationNumber={false}
        showNavigation={false}
        rounded={10}
        showButtons={false}
        showNumber={false}
        highlightedMaskClassName="lorem"
        accentColor={accentColor}
        startAt={startIndex}
        disableInteraction={false}
      />

      <div className="h-full w-full flex flex-col relative">
        <div
          className={`h-[${
            headerHeight - 50
          }px] w-full bg-[#7F2539] bg-cover flex flex-col justify-start items-center px-4 pt-4 gap-2 md:h-[240px]`}
        ></div>
        <div className="h-auto w-full absolute z-50 top-0" ref={headerRef}>
          <div className=" bottom-0 p-4 w-full z-50 flex flex-col gap-6 items-center justify-center">
            <img
              src={require(`../assets/images/${logoStateCourt}.png`)}
              alt=""
              className="w-[100px] h-[40px] mt-2 md:h-[120px] md:w-[300px]"
            />
            <div className="bg-white rounded-xl shadow-lg shadow-inner flex flex-row px-2 py-2 gap-2 w-full max-w-[640px]">
              <div className="flex flex-col items-center justify-center">
                <div className="w-2.5 h-2.5 bg-[#E09948] border border-white/40 rounded-full mb-1" />

                <div className="h-9 border-l-2 border-dashed border-gray-300" />

                <div className="w-2.5 h-2.5 bg-[#4999A3] rounded-full border border-white/40 mt-1" />
              </div>
              <div className="flex-grow flex flex-col justify-around gap-2 w-full">
                <div
                  data-tut="reactour__iso"
                  className="flex flex-row w-full items-center justify-center bg-[#0000000A] p-2 rounded-lg"
                >
                  <span
                    className={`text-sm flex-grow line-clamp-1 ${
                      generalStore.from == null
                        ? pathParams !== null && pathParams !== "/"
                          ? "text-gray-600 font-medium"
                          : "text-gray-400 font-light"
                        : "text-gray-600 font-medium"
                    }`}
                    onClick={() => {
                      if (
                        isActionEnabled &&
                        !generalStore.isWayfindingRunning
                      ) {
                        setShowSearchView(true);
                        generalStore.searchAction = "from";
                        setisTourOpen(false);
                      }
                    }}
                  >
                    {generalStore.from == null
                      ? pathParams !== null && pathParams !== "/"
                        ? "Location From QR Code"
                        : "Your Location"
                      : generalStore.from.name}
                  </span>
                  {(generalStore.from != null ||
                    (pathParams !== null && pathParams !== "/")) &&
                    isActionEnabled && (
                      <img
                        className="w-4 h-4"
                        src={closeIcon2}
                        onClick={() => {
                          generalStore.from = null;
                          setPathParams(null);
                        }}
                      />
                    )}
                </div>
                <div
                  data-tut="to"
                  className="flex flex-row w-full items-center justify-center bg-[#0000000A] p-2 rounded-lg"
                >
                  <span
                    className={`text-sm flex-grow line-clamp-1 ${
                      generalStore.to == null
                        ? "text-gray-400 font-light"
                        : "text-gray-600 font-medium"
                    }`}
                    onClick={() => {
                      if (
                        isActionEnabled &&
                        !generalStore.isWayfindingRunning
                      ) {
                        setShowSearchView(true);
                        setisTourOpen(false);
                        generalStore.searchAction = "to";
                      }
                    }}
                  >
                    {generalStore.to == null
                      ? "Where to?"
                      : generalStore.to.name}
                  </span>
                  {generalStore.to != null && isActionEnabled && (
                    <img
                      className="w-4 h-4"
                      src={closeIcon2}
                      onClick={() => {
                        // to help hide custom label
                        allowLoopIndex = 0;
                        generalStore.to = null;
                      }}
                    />
                  )}
                </div>
              </div>
              {isActionEnabled && !generalStore.isWayfindingRunning && (
                <div className="place-content-center px-2">
                  <img src={switchImage} onClick={handleSwitch} />
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className={`h-full w-full flex flex-col items-center bg-white relative`}
        >
          {renderMap()}
          <div className="absolute right-0 top-20 z-50 pe-4 overflow-y-auto max-h-[calc(100%-7rem)] scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
            {generalStore.floors.map((floor) => {
              if (floor.name !== "L21" && floor.name !== "L22")
                return (
                  <div
                    className={`flex items-center justify-center p-4 ${
                      floor.id == generalStore.activeFloor.id
                        ? "bg-[#9F2842] text-white"
                        : "bg-white"
                    } shadow-lg shadow-inner rounded-lg font-bold my-2`}
                    onClick={() => {
                      changeFloor(floor);
                    }}
                  >
                    {floor.name}
                  </div>
                );
            })}
          </div>

          {wayFindingControlsState &&
            wayFindingControlsState.placeDestination &&
            wayFindingControlsState.placeDestination.name &&
            wayFindingControlsState.finish && (
              <img
                src={repeat}
                onClick={() => {
                  onTakeMeThere(generalStore.tmtType == "lift");
                }}
                className={`absolute left-1/2 ml-[-55px] z-10 mt-[-70px] mb-4 bottom-20 w-[100px] `}
              />
            )}
        </div>
      </div>
    </Layout>
  );
});

export default Home;
